module.exports = __webpack_public_path__ + "img/element-datetime_picker.d462f51.svg";